import { render, staticRenderFns } from "./Tag-Soste.vue?vue&type=template&id=2a450fcc&scoped=true&lang=pug"
import script from "./Tag-Soste.vue?vue&type=script&lang=js"
export * from "./Tag-Soste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a450fcc",
  null
  
)

export default component.exports